/**
 * Created by Jerker Nord on 2024-02-14.
 */
import {LonerSymbol} from "../reels/symbols/main/LonerSymbol";
import {LonerSymbolStates, SymbolPositionData} from "../../core/reel/ReelInterfaces";
import {LonerBigWildPresentationSymbol2x2} from "../reels/symbols/main/bigsymbols/LonerBigWildPresentationSymbol2x2";
import {LonerBigWildPresentationSymbol3x3} from "../reels/symbols/main/bigsymbols/LonerBigWildPresentationSymbol3x3";
import {LonerBigWildSymbol2x2} from "../reels/symbols/main/bigsymbols/LonerBigWildSymbol2x2";
import {LonerBigWildSymbol3x3} from "../reels/symbols/main/bigsymbols/LonerBigWildSymbol3x3";
import {gsap} from "gsap";

export class LonerPoolBigWildSymbols {

    private _wild2x2PresentationSymbols:LonerBigWildPresentationSymbol2x2[];
    private _wild3x3PresentationSymbols:LonerBigWildPresentationSymbol3x3[];
    private _wild2x2Symbols:LonerBigWildSymbol2x2[];
    private _wild3x3Symbols:LonerBigWildSymbol3x3[];

    public init():void {
        //Need two of each since we can get a new one before the old one has done spin out complete
        this._wild2x2Symbols = [];
        for(let i:number = 0; i < 2; i++) {
            this._wild2x2Symbols.push(this.createNewWild2x2Symbol());
        }
        this._wild3x3Symbols = [];
        for(let i:number = 0; i < 2; i++) {
            this._wild3x3Symbols.push(this.createNewWild3x3Symbol());
        }

        this._wild2x2PresentationSymbols = [];
        for(let i:number = 0; i < 1; i++) {
            this._wild2x2PresentationSymbols.push(this.createNewWild2x2PresentationSymbol());
        }
        this._wild3x3PresentationSymbols = [];
        for(let i:number = 0; i < 1; i++) {
            this._wild3x3PresentationSymbols.push(this.createNewWild3x3PresentationSymbol());
        }
    }

    private createNewWild2x2Symbol():LonerBigWildSymbol2x2 {
        return new LonerBigWildSymbol2x2();
    }

    private createNewWild3x3Symbol():LonerBigWildSymbol3x3 {
        return new LonerBigWildSymbol3x3();
    }

    private createNewWild2x2PresentationSymbol():LonerBigWildPresentationSymbol2x2 {
        return new LonerBigWildPresentationSymbol2x2();
    }

    private createNewWild3x3PresentationSymbol():LonerBigWildPresentationSymbol3x3 {
        return new LonerBigWildPresentationSymbol3x3();
    }

    public getWild2x2Symbol(symbolName:string, symbolPositionData:SymbolPositionData):LonerSymbol {
        for(let i:number = 0; i < this._wild2x2Symbols.length; i++) {
            if(this._wild2x2Symbols[i].isUsed == false) {
                this._wild2x2Symbols[i].stackedSymbolName = symbolName;
                this._wild2x2Symbols[i].isUsed = true;
                this._wild2x2Symbols[i].symbolName = symbolName;
                this._wild2x2Symbols[i].reelPosition = symbolPositionData.position;
                this._wild2x2Symbols[i].reelId = symbolPositionData.reelID;
                return this._wild2x2Symbols[i];
            }
        }
        this._wild2x2Symbols.push(this.createNewWild2x2Symbol());
        return this.getWild2x2Symbol(symbolName, symbolPositionData);
    }

    public getWild3x3Symbol(symbolName:string, symbolPositionData:SymbolPositionData):LonerSymbol {
        for(let i:number = 0; i < this._wild3x3Symbols.length; i++) {
            if(this._wild3x3Symbols[i].isUsed == false) {
                this._wild3x3Symbols[i].stackedSymbolName = symbolName;
                this._wild3x3Symbols[i].isUsed = true;
                this._wild3x3Symbols[i].symbolName = symbolName;
                this._wild3x3Symbols[i].reelPosition = symbolPositionData.position;
                this._wild3x3Symbols[i].reelId = symbolPositionData.reelID;
                return this._wild3x3Symbols[i];
            }
        }
        this._wild3x3Symbols.push(this.createNewWild3x3Symbol());
        return this.getWild3x3Symbol(symbolName, symbolPositionData);
    }

    public getWild2x2PresentationSymbol(symbolName:string, symbolPositionData:SymbolPositionData):LonerSymbol {
        for(let i:number = 0; i < this._wild2x2PresentationSymbols.length; i++) {
            if(this._wild2x2PresentationSymbols[i].isUsed == false) {
                this._wild2x2PresentationSymbols[i].stackedSymbolName = symbolName;
                this._wild2x2PresentationSymbols[i].isUsed = true;
                this._wild2x2PresentationSymbols[i].symbolName = symbolName;
                this._wild2x2PresentationSymbols[i].reelPosition = symbolPositionData.position;
                this._wild2x2PresentationSymbols[i].reelId = symbolPositionData.reelID;
                return this._wild2x2PresentationSymbols[i];
            }
        }
        this._wild2x2PresentationSymbols.push(this.createNewWild2x2PresentationSymbol());
        return this.getWild2x2PresentationSymbol(symbolName, symbolPositionData);
    }

    public getWild3x3PresentationSymbol(symbolName:string, symbolPositionData:SymbolPositionData):LonerSymbol {
        for(let i:number = 0; i < this._wild3x3PresentationSymbols.length; i++) {
            if(this._wild3x3PresentationSymbols[i].isUsed == false) {
                this._wild3x3PresentationSymbols[i].stackedSymbolName = symbolName;
                this._wild3x3PresentationSymbols[i].isUsed = true;
                this._wild3x3PresentationSymbols[i].symbolName = symbolName;
                this._wild3x3PresentationSymbols[i].reelPosition = symbolPositionData.position;
                this._wild3x3PresentationSymbols[i].reelId = symbolPositionData.reelID;
                return this._wild3x3PresentationSymbols[i];
            }
        }
        this._wild3x3PresentationSymbols.push(this.createNewWild3x3PresentationSymbol());
        return this.getWild3x3PresentationSymbol(symbolName, symbolPositionData);
    }

    public getActivePresentationBigWild():LonerSymbol {
        for(let i:number = 0; i < this._wild3x3PresentationSymbols.length; i++) {
            if(this._wild3x3PresentationSymbols[i].isUsed == true &&
                this._wild3x3PresentationSymbols[i].reelPosition > 2 && this._wild3x3PresentationSymbols[i].reelPosition < 8 &&
                this._wild3x3PresentationSymbols[i].state !== LonerSymbolStates.SPIN_OUT) {
                return this._wild3x3PresentationSymbols[i];
            }
        }
        for(let i:number = 0; i < this._wild2x2PresentationSymbols.length; i++) {
            if(this._wild2x2PresentationSymbols[i].isUsed == true && this._wild2x2PresentationSymbols[i].reelPosition > 2 && this._wild2x2PresentationSymbols[i].reelPosition < 7) {
                return this._wild2x2PresentationSymbols[i];
            }
        }
        throw new Error("No active Big Wilds!");
    }
}